// extracted by mini-css-extract-plugin
export var imageborder = "PromotionCardImageSide-module--imageborder--d1b9a";
export var left = "PromotionCardImageSide-module--left--45ef9";
export var promocardimage = "PromotionCardImageSide-module--promocardimage--daa08";
export var promocardimagecontainer = "PromotionCardImageSide-module--promocardimagecontainer--9ab55";
export var promocardleft = "PromotionCardImageSide-module--promocardleft--8a2df";
export var promocardright = "PromotionCardImageSide-module--promocardright--9a785";
export var promocardtext = "PromotionCardImageSide-module--promocardtext--d56d3";
export var promocardtextcontainer = "PromotionCardImageSide-module--promocardtextcontainer--797e1";
export var right = "PromotionCardImageSide-module--right--48873";
export var title = "PromotionCardImageSide-module--title--5fe2e";